import { Dialog, styled } from '@mui/material';
import { PopupVariants } from '.';

export const CustomDialog = styled(Dialog)<{ variant: PopupVariants }>`
  .MuiDialog-paper {
    border-radius: 10px;
    width: 362px;

    &.SUCCESS {
      border: 1px solid ${({ theme }) => theme.palette['Feedback/Sucess']};
    }
    &.INFO {
      border: 1px solid ${({ theme }) => theme.palette['Feedback/Info']};
    }
    &.ERROR {
      border: 1px solid ${({ theme }) => theme.palette['Feedback/Erro']};
    }
  }
  .MuiDialogContent-root {
    padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};
  }
`;
